import { Input } from 'components/elements';
import { HalfContainer, SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();

  return (
    <SectionContainer>
      <HalfContainer>
        <Input
          type="text"
          name="code"
          label={t('common:group_code')}
          placeholder={t('common:group_code')}
        />
      </HalfContainer>
      <HalfContainer>
        <Input
          type="text-area"
          name="description"
          label={t('common:description')}
          placeholder={t('common:description')}
        />
      </HalfContainer>
    </SectionContainer>
  );
}
